module.exports = __webpack_public_path__ + "img/tanker-red.a1f538a3.svg";